import _ from 'lodash';
import { ElementRef, Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { fromEvent, Subject } from 'rxjs';
import { debounceTime, map, take, takeUntil } from 'rxjs/operators';
import { AccordionService } from './campaign-accordion.service';
import { CampaignService } from './campaign.service';
import { CampaignTabsStepService } from './campaign-tabs-step.service';
import { CampaignOptionListEventHandlerService } from './campaign-option-list-event-handler.service';
import { ToastService } from 'app/toast/services/toast.service';
import { FormService } from './form.service';

@Injectable({
  providedIn: 'root'
})
export class CampaignOptionFormService {
    public container: ElementRef = null;
    public raw: any = {
        id: null,
        campaignTypeData: {
            presetOptions: []
        }
    };

    public form: UntypedFormGroup = null;
    public schema: any = null;

    public submitted: boolean = false;

    get dirty():boolean {
        return this.form.dirty;
    }

    get invalid():boolean {
        return this.form.invalid;
    }

    get valid():boolean {
        return this.form.valid;
    }

    public takeUntilSubject: Subject<any> = new Subject();

    constructor(
        public store: Store,
        public accordionService: AccordionService,
        public campaignTabsStepService: CampaignTabsStepService,
        public campaignOptionListEventHandlerService: CampaignOptionListEventHandlerService,
        public campaignService: CampaignService,
        public formService: FormService,
        public toastService: ToastService
    ) {
        this.campaignOptionListEventHandlerService.onUpdateCampaignOptionList.pipe(
          map(list => {
            return _.map(list, ({ data }) => {
              return data;
            });
          }),
          takeUntil(this.takeUntilSubject)
        ).subscribe(list => {
          this.raw.campaignTypeData.presetOptions = list;
        });
    }

    private _getTopOffset(element: HTMLElement): number {
        const labelOffset = 50;
        return element.getBoundingClientRect().top + window.scrollY - labelOffset;
    }
    
    generate() {
        this.campaignService.generateForm(this.form, this.schema);
    }

    initialize(option) {
        this.raw = option;
        this.campaignService.initializeForm(this.form, { ...option }, this.schema);
    }

    save() {
        const name = this.form.get('name');
        const trimedName = _.trim(name.value);
        name.setValue(trimedName);

        const exclude = [];
        const isValid = this.formService.isFormValid(this.form, exclude);
        if(!isValid) {
          return this.isNotValid();
        }
    
        /*
        const id = this.raw.id;
        const type = id ? putCampaign.type: createCampaign.type;
        const payload = this.campaignService.generateRequestObject(this.form, this.schema, this.raw);
        return this.store.dispatch({ type, payload: { ...payload, id }, redirect });
        */
    }
    
    isNotValid() {
        const { form } = this;
    
        form.markAllAsTouched();
        this.submitted = true;
    
        const element: HTMLElement = this.container.nativeElement.querySelector(".ng-invalid");
        if(!element) {
          return false;
        }
        const panel = _.get(element.dataset, 'panel', null);
        if(!_.isNull(panel)) {
            this.accordionService.map[panel].expanded = true;
        }
    
        fromEvent(window, "scroll").pipe(
          debounceTime(100),
          take(1),
          takeUntil(this.takeUntilSubject)
        ).subscribe(() => element.focus());
    
        setTimeout(()=>{
          window.scroll({
            top: this._getTopOffset(element),
            left: 0,
            behavior: "smooth"
          });
        }, 500);
    
        return false;
    }

    public reset() {
        this.container = null;
        this.raw = {
            id: null
        };

        this.form = null;

        this.submitted = false;
    }
}
